import React from 'react'
import { Link } from 'react-router-dom'

const serviceLinks = [
  'Mobile development',
  'Web applications',
  'Cloud & backend',
  'SaaS platforms',
  'Technical leadership'
]

const Footer: React.FC = () => {
  return (
    <footer className='bg-surface border-t border-black/[0.06]'>
      <div className='max-w-[1060px] mx-auto px-4 md:px-10 pt-12 flex flex-col md:flex-row justify-between items-start gap-10 md:gap-0'>
        <div>
          <a
            className='font-hd font-extrabold text-[20px] tracking-[-0.8px] text-ink no-underline'
            href='#top'
          >
            zeiger<span className='text-pop not-italic'>.</span>
          </a>
          <p className='text-[13px] text-ink3 mt-2 leading-[1.6]'>
            Software studio.
            <br />
            United States.
          </p>
        </div>

        <div className='flex gap-12 md:gap-16'>
          <div>
            <h4 className='text-[11px] font-bold tracking-[2px] uppercase text-ink2 mb-[14px]'>
              Services
            </h4>
            {serviceLinks.map((item) => (
              <a
                key={item}
                href='#services'
                className='block text-[13.5px] text-ink3 no-underline mb-[10px] hover:text-pop transition-colors'
              >
                {item}
              </a>
            ))}
          </div>

          <div>
            <h4 className='text-[11px] font-bold tracking-[2px] uppercase text-ink2 mb-[14px]'>
              Company
            </h4>
            <a
              href='#contact'
              className='block text-[13.5px] text-ink3 no-underline mb-[10px] hover:text-pop transition-colors'
            >
              Contact
            </a>
            <Link
              to='/privacy-policy'
              className='block text-[13.5px] text-ink3 no-underline mb-[10px] hover:text-pop transition-colors'
            >
              Privacy policy
            </Link>
            <Link
              to='/terms-of-service'
              className='block text-[13.5px] text-ink3 no-underline mb-[10px] hover:text-pop transition-colors'
            >
              Terms of service
            </Link>
          </div>
        </div>
      </div>

      <div className='max-w-[1060px] mx-auto px-4 md:px-10 py-5 mt-5 border-t border-black/[0.06] text-[12px] text-ink4'>
        &copy; 2026 Zeiger Software Solutions, LLC
      </div>
    </footer>
  )
}

export default Footer
